import { OPMData } from '~types/index'

const onOPMTurnOn = ({
  turnOn,
  data,
  onSuccessAction,
  getOPM,
}: {
  turnOn: boolean
  data: OPMData
  onSuccessAction: (data: OPMData) => void
  getOPM: () => void
}) => {
  if (turnOn && data?.getOnlinePaymentProviderForm) {
    onSuccessAction(data)
  } else if (turnOn) {
    getOPM()
  }
}

export default onOPMTurnOn
